module.exports = __webpack_public_path__ + "static/sensor-calibration.2793b5db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TheSensor/sensor-calibration.jpg
// module id = 460
// module chunks = 72476233251319